/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * An interface for retrieving documents by URL that the compiler uses
 * to load templates.
 */
var /**
 * An interface for retrieving documents by URL that the compiler uses
 * to load templates.
 */
ResourceLoader = (function () {
    function ResourceLoader() {
    }
    /**
     * @param {?} url
     * @return {?}
     */
    ResourceLoader.prototype.get = /**
     * @param {?} url
     * @return {?}
     */
    function (url) { return ''; };
    return ResourceLoader;
}());
/**
 * An interface for retrieving documents by URL that the compiler uses
 * to load templates.
 */
export { ResourceLoader };
//# sourceMappingURL=resource_loader.js.map